"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSessionCookie = void 0;

var _cuid = _interopRequireDefault(require("cuid"));

var _m = require("@mutant-ws/m");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setCookie = function setCookie() {
  var newCookie = (0, _cuid.default)();
  var date = new Date();
  var daysToExpire = 3500;
  date.setTime(date.getTime() + daysToExpire * 24 * 60 * 60 * 1000);
  document.cookie = "mutant=".concat(newCookie, "; path=/; expires=").concat(date.toGMTString());
  return newCookie;
};

var getSessionCookie = function getSessionCookie() {
  return (0, _m.pipe)((0, _m.split)("; "), (0, _m.find)((0, _m.startsWith)("mutant=")), (0, _m.when)(_m.is, (0, _m.pipe)((0, _m.split)("="), (0, _m.get)(1)), setCookie))(document.cookie);
};

exports.getSessionCookie = getSessionCookie;